export default {"src":"/_next/static/media/file-list-3-fill.57beb31b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};